import React, { Component } from "react";
import "antd/dist/antd.css";
import axios from "axios";
import { PrinterFilled } from "@ant-design/icons";
import { Button } from "antd";
import Loading from "@beisen-phoenix/loading";

import NoQuestionBank from "../../imgs/nopermission.png";

import "./sinosig_question_bank.css";

const PrintBtnID = "sinosigQuestionBankPrintBtn";

export class Sinosig_QuestionBank extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      questionList: [],
      errorMessage: '',
    };
  }
  
  componentDidMount() {
    const urlParams = new URLSearchParams(window.location.search);
    const tenantId = urlParams.get("tenantId");
    const applyId = urlParams.get("applyId");
    const signValue = urlParams.get("signValue");

    this.loadPage(tenantId, applyId, signValue);
    this.addListener();
  }

  componentWillUnmount() {
    window.removeEventListener("beforeprint", this.beforePrint);
    window.removeEventListener("afterprint", this.afterPrint);
  }

  addListener = () => {
    window.addEventListener("beforeprint", this.beforePrint);
    window.addEventListener("afterprint", this.afterPrint);
  };

  beforePrint = () => {
    this.setPrintBtnDisplay("none");
  };

  afterPrint = () => {
    this.setPrintBtnDisplay("");
  };

  setPrintBtnDisplay = (display) => {
    if (document.getElementById(PrintBtnID)?.style) {
      document.getElementById(PrintBtnID).style.display = display;
    }
  };

  loadPage = (tenantId, applyId, signValue) => {
    this.setState({ loading: true });

    axios
      .get(`/api/SinosigQB/GetQuestionBank?tenantId=${tenantId}&applyId=${applyId}&signValue=${signValue}`, {})
      .then((res) => {
        if (res.status === 200) {
          if (res?.data?.code === "200") {
            this.setState({ questionList: res.data.data || [] })
          }else {
            this.setState({ errorMessage: res.data.message })
          }
        }
      })
      .catch((reason) => {
        this.setState({
          errorMessage: "网络异常，请稍后重试！",
        });
      })
      .finally(() => {
        this.setState({ loading: false });
      });
  };

  renderQuestions = () => {
    const { questionList } = this.state;

    return (questionList || []).map((cat_item, cat_index) => {
      const { category = "", keyPoint = "", questions = [] } = cat_item;

      return (
        <div
          className="interview-assistant__questions"
          key={`cat_index_${cat_index}`}
        >
          <div className="interview-assistant__questions-item">
            <div className="question-body">
              <span className="index">{`${cat_index + 1}. `}</span>
              <div className="describe">
                <span className="dimension-name">{category}</span>
                <span className="divider" />
                <span className="main-interview-question">{keyPoint}</span>
              </div>
            </div>
            <div className="interview-assistant__questions-item__inquire">
              <div className="dropdown-body">
                {(questions || []).map((item, index) => {
                  const { question = "", subQuestions = [] } = item;

                  return (
                    <div
                      className="item-wrapper-container-sinosig"
                      key={`question_${index}`}
                    >
                      {`${index + 1}) ${question}`}
                      {(subQuestions || []).map((subItem, subIndex) => {
                        return (
                          <div
                            className="item-wrapper-sinosig"
                            key={`sub_question_${subIndex}`}
                          >
                            <label>{subItem.title}</label>：
                            <span>{subItem.question}</span>
                          </div>
                        );
                      })}
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      );
    });
  };

  renderPrintBtn = () => {
    return (
      <div className="printBtn" id={PrintBtnID}>
        <Button
          type="primary"
          shape="round"
          icon={<PrinterFilled />}
          onClick={window.print}
        >
          打印
        </Button>
      </div>
    );
  };

  render() {
    const { loading, errorMessage } = this.state;

    return loading ? (
      <Loading description="加载中..." />
    ) : (
      errorMessage ?
        <div className="sinosig_question_bank_error">
          <img src={NoQuestionBank} />
          <p>{errorMessage}</p>
        </div>
      :
        <div className="sinosig_question_bank">
          {this.renderPrintBtn()}
          {this.renderQuestions()}
        </div>
    );
  }
}
